import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../customHooks/useDeleteHook";
const AccountInfoComponent = loadable(
  () => import("../../components/AccountInfo/AccountInfoList")
);

const AccountInfo = () => {
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["account-info"],
  });

  const handleDelete = async (id: any) => {
    const url = `${APIS.COA}${id}/`;
    try {
      await mutateAsync({ url });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>
          Account Information
        </h1>
      </div>
      <AccountInfoComponent handleDelete={handleDelete} isLoading={isLoading} />
    </div>
  );
};

export default AccountInfo;
